/**
 * ECO Haustechnik — Testimonials config
 *
 * Platzhalter-Stimmen für den Slider auf der Startseite.
 * Bitte durch echte, freigegebene Kundenstimmen ersetzen, sobald vorhanden.
 * Jedes Element: { quote, role, location, initials }
 */

export const TESTIMONIALS = [
  {
    quote: "Die Koordination über BIM hat bei uns viele Rückfragen auf der Baustelle vermieden. Technik wurde planerisch durchdacht, bevor der erste Nagel gesetzt war.",
    role: "Projektleitung Bauträger",
    location: "Wien",
    initials: "BT",
  },
  {
    quote: "Was mich überzeugt hat: Es wird keine Lösung über das Gebäude gestülpt. Erst wurde zugehört, dann ausgelegt — und am Ende sitzt alles.",
    role: "Privater Bauherr Einfamilienhaus",
    location: "Niederösterreich",
    initials: "BH",
  },
  {
    quote: "Für unsere Wohnanlage brauchten wir Zentraltechnik mit sauberer wohnungsweiser Zuordnung. Die Verbrauchserfassung und das Monitoring geben uns heute den Überblick, den wir vorher nie hatten.",
    role: "Hausverwaltung Mehrfamilienhaus",
    location: "Mödling",
    initials: "HV",
  },
  {
    quote: "Die Abstimmung mit dem Planungsteam war technisch sauber. Besonders die Schnittstellen zwischen Heizung, PV und Gebäudeautomation wurden vorab durchgespielt.",
    role: "Architekturbüro",
    location: "Wien & NÖ",
    initials: "AR",
  },
  {
    quote: "Nach der Übergabe wurde die Anlage noch zweimal nachjustiert. Das zählt für uns zum Service — ohne Diskussion, ohne Zusatzkosten im Rahmen der Inbetriebnahme.",
    role: "Eigentümer Sanierungsprojekt",
    location: "Baden",
    initials: "ES",
  },
];
